import type { RendererProps } from "../core/element-registry"
import { useAtomDefaults } from "../contexts/atom-defaults-context"
import { AspectRatio } from "../components/ui/aspect-ratio"
import { ElementRenderer } from "./element-renderer"

const DEFAULT_RATIO = 16 / 9

export function AspectRatioRenderer({ element }: RendererProps) {
  // aspect-ratio is a pure layout primitive — default-theme.json has no
  // variants/sizes ({}) — but we still look up atomDefaults so a future
  // theme can opt in to a defaultVariant / defaultRadius and have it surface
  // for external assertion.
  const atomDefaults = useAtomDefaults("aspect-ratio")
  const resolvedVariant = element.variant ?? atomDefaults.defaultVariant ?? "default"
  const ratio = (element as { ratio?: number }).ratio ?? DEFAULT_RATIO

  return (
    <AspectRatio
      ratio={ratio}
      className={element.className}
      data-testid={`aspect-ratio-${element.id}`}
      data-atom-type="aspect-ratio"
      data-variant={resolvedVariant}
      data-ratio={ratio}
    >
      {element.children?.map((child) => (
        <ElementRenderer key={child.id} element={child} />
      ))}
    </AspectRatio>
  )
}
